module.exports = __webpack_public_path__ + "img/realplayer_features03.166d3db0.svg";